import authenticationReducer from "./authenticationReducer.js";
import localizationReducer from "./localizationReducer.js";
import modalReducer from "./modalReducer";
import userSettingsReducer from "./userSettingsReducer";

export default {
    authentication: authenticationReducer,
    localization: localizationReducer,
    userSettings: userSettingsReducer,
    modal: modalReducer,
};